import styled from 'styled-components';
import { Button } from '../Button/Button';

export const StyledBackButton = styled(Button)`
  width: 32px;
  height: 32px;
`;
